export default "__VITE_ASSET__TmsgcZnT__"